export default __webpack_public_path__ + "static/media/iphone-black.f6e9aee0.png";